import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useAppDispatch, useAppSelector } from 'hooks/store';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RESET_NOTIFICATION } from 'store/account/actionsTypes';

import { StartFreeTrialModal } from '../ChangeModals';

export const PreparationPage = () => {
  const dispatch = useAppDispatch();
  const [openStartFreeTrial, setOpenStartFreeTrial] = useState(false);
  const notification = useAppSelector((state) => state.account.notification);

  useEffect(() => {
    if (notification === 'start-free-trial') {
      setOpenStartFreeTrial(true);
    }

    return () => {
      dispatch({
        type: RESET_NOTIFICATION,
      });
    };
  }, []);

  return (
    <div className="w-full h-full flex items-center justify-center">
      <StartFreeTrialModal open={openStartFreeTrial} setOpen={setOpenStartFreeTrial} />
      <div className="flex flex-col items-center space-y-3">
        <ChatBubbleLeftRightIcon className="h-10 w-10 text-gray-500" />
        <div className="text-lg font-medium">
          <FormattedMessage id="noSubscription" />
        </div>
        <div className="text-lg text-center">
          <FormattedMessage id="startFreeTrialDesc" />
        </div>
        <button
          onClick={() => setOpenStartFreeTrial(true)}
          type="button"
          className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <FormattedMessage id="startFreeTrial" />
        </button>
      </div>
    </div>
  );
};
